
export const CONNECT_USER = "CONNECT_USER";
export const LOGOUT_USER = "LOGOUT_USER";